import { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  fruitBaskets,
  getProduct,
  images,
  initialAddresses,
  products,
  serviceAreas,
  shakeProducts,
  timeSlots,
  weekdays,
} from "../data";
import { useApp } from "../store";
import {
  AddressCard,
  Brand,
  DeliveryCard,
  EmptyState,
  PageHeader,
  PrimaryButton,
  ProductCard,
  StatusBadge,
} from "../components/UI";

import "../css/About.css";
export function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="about-page">
      <div className="about-hero">
        <div className="container-xl">
          <span className="eyebrow">Our why</span>
          <h1>Freshness, on your schedule.</h1>
          <p>
            We started with a simple idea: busy people shouldn’t have to
            remember every small nutrition and grocery task.
          </p>
        </div>
      </div>
      <div className="container narrow about-copy">
        <p>
          We prepare your natural protein shakes fresh and purchase fresh fruits
          based on scheduled demand instead of keeping large quantities sitting
          in storage.
        </p>
        <blockquote>“You schedule it. We bring it fresh.”</blockquote>
        <p>
          Our goal is to make everyday nutrition quietly reliable—especially for
          Pune’s busy professionals, couples and families.
        </p>
        <div className="freshness-banner">
          <i className="fa-solid fa-location-dot" />
          <div>
            <strong>Starting local in Pune</strong>
            {/* <p>
              We currently serve selected areas. Enter your pincode before
              scheduling.
            </p> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
